const VALUES_REG = /,(?![^(]*\))/
const PARTS_REG = /\s(?![^(]*\))/
const LENGTH_REG = /^[0-9]+[a-zA-Z%]+?$/

type BoxShadow = {
  inset: boolean
  offsetX: string | number
  offsetY: string | number
  blurRadius: string | number
  spreadRadius: string | number
  color: string | undefined
}

const parseValue = (str: string): BoxShadow => {
  const parts = str.split(PARTS_REG)
  const inset = parts.includes('inset')
  const last = parts.slice(-1)[0]
  const color = !isLength(last) ? last : undefined

  const nums = parts
    .filter(n => n !== 'inset')
    .filter(n => n !== color)
    .map(toNum)
  const [offsetX, offsetY, blurRadius, spreadRadius] = nums

  return {
    inset,
    offsetX,
    offsetY,
    blurRadius,
    spreadRadius,
    color,
  }
}

const stringifyValue = (obj: BoxShadow, multipler: (value: number) => string): string => {
  const {inset, offsetX = 0, offsetY = 0, blurRadius = 0, spreadRadius, color} = obj || {}

  return [inset ? 'inset' : null, offsetX, offsetY, blurRadius, spreadRadius, color]
    .filter(v => v !== null && v !== undefined)
    .map(s => toVw(s, multipler))
    .map(s => ('' + s).trim())
    .join(' ')
}

const isLength = (v: string) => v === '0' || LENGTH_REG.test(v)

const toNum = (v: string) => {
  if (isNaN(+v)) return v

  const n = parseFloat(v)
  return !isNaN(n) ? n : v
}
const toVw = (n: string | number | undefined | null, multipler: (value: number) => string) =>
  typeof n === 'number' && n !== 0 ? multipler(n) : n

export const parse = (str: string): BoxShadow[] =>
  str
    .split(VALUES_REG)
    .map(s => s.trim())
    .map(parseValue)

export const stringify = (arr: Array<BoxShadow>, multipler: (value: number) => string): string =>
  arr.map(v => stringifyValue(v, multipler)).join(', ')

export const isFluid = (str: string): boolean => {
  return !!parse(str).find(s => {
    const {offsetX = 0, offsetY = 0, blurRadius = 0, spreadRadius} = s || {}

    return [offsetX, offsetY, blurRadius, spreadRadius].find(v => typeof v === 'number' && v !== 0)
  })
}
